import(/* webpackMode: "eager" */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/app/[locale]/(auth)/signup/Register.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/app/[locale]/(auth)/signup/SignupForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/legacy/components/base/Frame.module.scss");
